import { UserAuth } from "./context/AuthContext";
import { Link, useNavigate } from 'react-router-dom';
import vocabulary_icon from './vocabulary_icon.png';
import { useState } from 'react';
import TeacherCheckWords from "./TeacherCheckWords";

function TeachersPage() {
    const {user, logout} = UserAuth();
    const navigate = useNavigate();
    const [mainContent, setMainContent] = useState('');

    const teacherCheckWords = <TeacherCheckWords />

    const handleLogout = async () => {
        try {
            await logout()
            navigate('/')
        } catch (e) {
            console.log(e.message)
        }
    }

    return (
        <div className="relative">
            <div className="h-screen bg-fixed bg-center bg-cover" style={{ backgroundImage: "url('/images/inca-background.jpg')" }}>
            <div className="fixed top-0 left-0 w-full bg-white bg-opacity-50 backdrop-blur-md py-4 px-8 z-50">
                <div className="flex justify-between items-center space-x-2">
                    <Link to='/' className='text-black text-sm sm:text-2xl'>Cuenta del profesor</Link>
                    <div className="space-x-2">
                        <button onClick={() => setMainContent(teacherCheckWords)} type="button" className="transition-all ease-in duration-75 text-black hover:text-white border border-violet-700 hover:bg-violet-800 focus:ring-4 focus:outline-none focus:ring-violet-300 font-medium rounded-lg text-sm px-0 py-0 text-center dark:border-violet-400 dark:text-violet-400 dark:hover:text-white dark:hover:bg-violet-500 dark:focus:ring-violet-900 overflow-hidden mt-1 sm:mt-0">
                            <div className="flex flex-row items-center">
                                <img src={vocabulary_icon} className="h-10" />
                                <p className="px-0 sm:px-1 py-1 text-xs sm:text-sm">Chequear palabras</p>
                            </div>
                        </button>
                    </div>
                    <button onClick={handleLogout} className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-md font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-orange-400 to-red-400 group-hover:from-orange-400 group-hover:to-red-400 dark:text-white dark:hover:text-gray-900 focus:ring-4 focus:outline-none focus:ring-red-100 dark:focus:ring-red-400">
                        <span className="px-2 sm:px-5 text-sm sm:text-md relative py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">Salir</span>
                    </button>
                </div>
            </div>
                {/* Добавляем полупрозрачный и заблюренный слой */}
                <div className="h-full w-full bg-white bg-opacity-50 backdrop-blur-md flex flex-col justify-center items-center">
                    {mainContent}
                </div>
            </div>
        </div>
    )
}

export default TeachersPage;